import { Person } from '@kavrillon/tree-core';

interface IProps {
  person: Person;
}

export const PersonNickname = ({ person: p }: IProps) => (
  <>{p.nickname ? <em>{p.nickname}</em> : ''}</>
);
